/**
 * Site-wide logo carousel functionality
 */
jQuery(function($){
    $('.logo-carousel').cycle();
});
